module.exports = __webpack_public_path__ + "static/img/chart4.9b881dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart4.png
// module id = QR2y
// module chunks = 1